import React, { useState } from "react";
import SdkSelector from "@/components/SdkSelector";
import ReactGuide from "@/components/JavaScriptGuides/ReactGuide";
import JavaScriptGuide from "@/components/JavaScriptGuides/JavaScriptGuide";

type SdkOption = "react" | "javascript";

const JavascriptSdkExamples: React.FC = () => {
  const [selected, setSelected] = useState<SdkOption>("react");

  return (
    <div>
      <SdkSelector selected={selected} onSelect={setSelected} />

      {selected === "react" && <ReactGuide />}
      {selected === "javascript" && <JavaScriptGuide />}
    </div>
  );
};

export default JavascriptSdkExamples;
